import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';

import IngestionActions from '../../ingestionActions';
import InputLabel from '../InputLabel';
import InputToolTip from '../../toolTip/inputToolTip/index';
import InputAddSubIcons from '../InputAddIcons';
import './index.scss';
import { findDuplicateNames, isDuplicate } from '../../../utils/generic/helper';

const InputTextField = ({
  label,
  labelSuffix,
  labelSize,
  isMandatory,
  inputHeight,
  showToolTip,
  ingestedData,
  ingestionAction,
  handleIngestionActions,
  isIngestionActionDisabled,
  onBlurDisable,
  noOfFields,
  showIcons,
  addDelEntryRow,
  getAllMultiInputData,
  showInputErrors,
  resetInputs,
  updateResetInputs,
  name,
  validateData,
  multInputValues,
  disabled,
  limit,
  duplicateValidation,
  ...inputProps
}) => {
  const className = `width-100 ${inputHeight}`;
  const [textInputs, setTextInputs] = useState([]);
  const [duplicateValues, setDuplicateValues] = useState([]);
  const addTextInput = () => {
    setTextInputs([...textInputs, { name: `${name}${textInputs.length + 1}`, value: '' }]);
  };
  const onInputValueChange = (val, id) => {
    const textInputsCopy = JSON.parse(JSON.stringify(textInputs));
    textInputsCopy.forEach((item, index) => {
      if (item.name == id) {
        item.value = val;
      }
    });
    if (duplicateValidation) {
      const updatedArray = findDuplicateNames([
        ...textInputsCopy.map(val => val.value),
        inputProps?.value,
      ]);
      setDuplicateValues([...updatedArray]);
    }
    setTextInputs(textInputsCopy);
    getAllMultiInputData(textInputsCopy);
  };

  useEffect(() => {
    if (duplicateValidation) {
      const updatedArray = findDuplicateNames([
        ...textInputs.map(val => val.value),
        inputProps?.value,
      ]);
      setDuplicateValues([...updatedArray]);
    }
  }, [inputProps?.value]);

  const callToAddInputs = () => {
    if (duplicateValidation) {
      if (
        !isDuplicate([...textInputs.map(val => val.value), inputProps?.value]) &&
        textInputs?.length < limit
      )
        addTextInput();
    } else {
      if (textInputs?.length < limit) {
        addTextInput();
      }
    }
    addDelEntryRow(textInputs?.length, [...textInputs.map(val => val.value), inputProps?.value]);
  };

  const removeTextInput = name => {
    let textInputsCopy = JSON.parse(JSON.stringify(textInputs));
    textInputsCopy = textInputsCopy.filter(el => el.name != name);
    if (duplicateValidation) {
      const updatedArray = findDuplicateNames([
        ...textInputsCopy.map(val => val.value),
        inputProps?.value,
      ]);
      setDuplicateValues([...updatedArray]);
    }
    setTextInputs(textInputsCopy);
    getAllMultiInputData(textInputsCopy);
  };

  useEffect(() => {
    if (resetInputs) {
      textInputs.length > 0 && setTextInputs([]);
      updateResetInputs();
    }
  }, [resetInputs]);

  useEffect(() => {
    if (multInputValues.length > 0) {
      const multiInputValueArr = multInputValues.map((x, i) => {
        return { name: `${name}${i + 1}`, value: x };
      });
      setTextInputs(multiInputValueArr);
      getAllMultiInputData(multiInputValueArr);
      if (duplicateValidation) {
        const updatedArray = findDuplicateNames([...multInputValues, inputProps?.value]);
        setDuplicateValues([...updatedArray]);
      }
    } else {
      setTextInputs([]);
      getAllMultiInputData([]);
    }
  }, [multInputValues]);

  const showErrors = element => {
    if (element?.value) {
      let error = validateData(element.value);
      const duplicateCheckFlag = Boolean(duplicateValues?.length) && duplicateValidation;
      if (duplicateCheckFlag && duplicateValues.includes(element?.value)) {
        error = 'Duplicate value detected';
      }
      if (showInputErrors && error) {
        return <p className="error-text multiInput-er">{error}</p>;
      }
    }
  };
  const duplicateValFlag = duplicateValues.includes(inputProps?.value);
  return (
    <div className="text-field">
      {label && (
        <InputLabel
          labelFor="inputLabel"
          text={label}
          textSuffix={labelSuffix}
          size={labelSize}
          isMandatory={isMandatory}
        />
      )}
      <div className={showIcons && 'inputWithIcon mb-15'}>
        <InputToolTip showToolTip={showToolTip}>
          <TextField
            className={className}
            {...inputProps}
            onBlur={
              onBlurDisable
                ? inputProps.onBlur
                : () => {
                    inputProps.onChange({ target: { value: inputProps.value.trim() } });
                  }
            }
            disabled={disabled}
            error={duplicateValFlag ? true : inputProps?.error}
            helperText={duplicateValFlag ? 'Duplicate value detected' : inputProps?.helperText}
          />
        </InputToolTip>
        {showIcons && (
          <InputAddSubIcons
            showInputs={true}
            showMinus={false}
            addTextInput={addTextInput}
            callToAddInputs={callToAddInputs}
            disabled={disabled}
          />
        )}
      </div>
      <IngestionActions
        className="pt-10"
        isDisabled={isIngestionActionDisabled}
        ingestionAction={ingestionAction}
        handleIngestionActions={handleIngestionActions}
      >
        {ingestedData && <p className="input-ingested-text">{ingestedData}</p>}
      </IngestionActions>

      {textInputs.map((element, index) => {
        return (
          <>
            <div key={index} className={showIcons && 'mb-15'}>
              <div className={showIcons && 'inputWithIcon'}>
                <InputToolTip showToolTip={showToolTip}>
                  <TextField
                    key={element.id}
                    name={element.name}
                    className={`${className}${
                      (duplicateValidation && duplicateValues.includes(element.value)) ||
                      (validateData(element.value) && showInputErrors)
                        ? ' error-border'
                        : ''
                    }`}
                    value={element.value}
                    onChange={e => {
                      onInputValueChange(e.target.value, element.name);
                    }}
                    variant="outlined"
                    disabled={disabled}
                  />
                </InputToolTip>

                {showIcons && (
                  <InputAddSubIcons
                    index={index + 1}
                    showInputs={true}
                    addTextInput={addTextInput}
                    callToAddInputs={callToAddInputs}
                    removeTextInput={removeTextInput}
                    name={element.name}
                    disabled={disabled}
                    //className="childItem2"
                  />
                )}
              </div>
              {showIcons && showErrors(element)}
            </div>
          </>
        );
      })}
    </div>
  );
};

InputTextField.propTypes = {
  label: PropTypes.string,
  labelSuffix: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  variant: PropTypes.string,
  size: PropTypes.string,
  labelSize: PropTypes.string,
  isMandatory: PropTypes.bool,
  inputHeight: PropTypes.oneOf(['ht-lg', 'ht-md']),
  showToolTip: PropTypes.bool,
  ingestionAction: PropTypes.string,
  ingestedData: PropTypes.string,
  handleIngestionActions: PropTypes.func,
  isIngestionActionDisabled: PropTypes.bool,
  onBlurDisable: PropTypes.bool,
  noOfFields: PropTypes.number,
  showIcons: PropTypes.bool,
  addDelEntryRow: PropTypes.func,
  showInputErrors: PropTypes.any,
  resetInputs: PropTypes.bool,
  updateResetInputs: PropTypes.func,
  multInputValues: PropTypes.array,
  getAllMultiInputData: PropTypes.func,
  limit: PropTypes.number,
  duplicateValidation: PropTypes.bool,
};
InputTextField.defaultProps = {
  variant: 'outlined',
  size: 'small',
  labelSize: '16',
  onChange: () => {},
  isMandatory: false,
  inputHeight: 'ht-md',
  showToolTip: true,
  ingestionAction: 'none',
  ingestedData: '',
  handleIngestionActions: () => {},
  isIngestionActionDisabled: false,
  onBlurDisable: false,
  noOfFields: 1,
  showIcons: false,
  addDelEntryRow: () => {},
  showInputErrors: '',
  resetInputs: false,
  updateResetInputs: () => {},
  validateData: () => {},
  multInputValues: [],
  getAllMultiInputData: () => {},
  limit: 9,
  duplicateValidation: false,
};
export default InputTextField;
